import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '@mui/material';
import { useContext, useMemo } from 'react';

import './styles.scss';
import PricingGroup from '../../../../components/pricing-group';
import { PricingContext } from '../../../../providers/pricing-provider';

import Trade from './trades';

const PricingTrades = () => {
  const ITEMS = [
    { key: 'instrument', label: 'Instrument' },
    { key: 'contract', label: 'Contract' },
    { key: 'expiry', label: 'Expiry' },
    { key: 'strike', label: 'Strike' },
    { key: 'call_put', label: 'Call / Put' },
    { key: 'notional', label: 'Notional' },
    { key: 'barriers', label: 'Barriers' },
    { key: 'payment_time', label: 'Payment Time' },
  ];

  const { trades, setTrades, showRiskLadder, setShowRiskLadder } = useContext(PricingContext);

  const renderTrades = useMemo(() => {
    return trades.map((trade: any) => (
      <div className="block" key={trade.id}>
        <Trade tradeId={trade.id} />
      </div>
    ));
  }, [trades]);

  const handleAddTrade = () => {
    setTrades((prev: any) => {
      const existingIds = new Set(prev.map((trade: any) => trade.id));
      let nextNumber = prev.length + 1;
      let nextId = `trade_${nextNumber}`;

      while (existingIds.has(nextId)) {
        nextNumber++;
        nextId = `trade_${nextNumber}`;
      }

      return [
        ...prev,
        {
          id: nextId,
          data: {},
        },
      ];
    });
  };

  return (
    <div className="pricing-trades">
      <PricingGroup label={'Trade'} isClosable defaultOpen={true}>
        <div className="pricing-trades-container">
          <div className="fixed-panel">
            {ITEMS.map((item) => (
              <span className="item" key={item.key}>
                {item.label}
              </span>
            ))}
          </div>
          <div className="content-panel-container">
            <div className="content-panel">
              {renderTrades}
              <div className="block">
                <div className="add-new-trade" onClick={handleAddTrade}>
                  <FontAwesomeIcon icon={faCirclePlus} className="icon" />
                  <span>Add new trade</span>
                </div>
              </div>
            </div>
            <div className="show-risk-ladder">
              <label>
                <Checkbox
                  checked={showRiskLadder}
                  onChange={(e) => setShowRiskLadder(e.target.checked)}
                  size="small"
                />
                <span>Show Risk Ladder</span>
              </label>
            </div>
          </div>
        </div>
      </PricingGroup>
    </div>
  );
};

export default PricingTrades;
